import {
    IAcompanhamentosVistoria,
    IAcompanhamentoVistoriaFiltro,
} from "../../../Interfaces/VistoriaEntregaChaves/AcompanhamentosVistoria/AcompanhamentosVistoriaInterfaces";
import Axios from "../../Config/API";
import Service from "../../Service";

export async function AcompanhamentoVistoriaService<
    TResponseType extends IAcompanhamentosVistoria | Blob
>(filtro: IAcompanhamentoVistoriaFiltro, exportExcel?: boolean) {
    return Service(
        Axios.post<TResponseType>(
            `/vistoria/casovistoria/relatorioacompanhamentocasovistoriaentregachavesperiodo`,
            filtro,
            { responseType: exportExcel ? "blob" : "json" }
        )
    );
}
